/* src/app/component/session-dialog/session-dialog.component.scss */
h3 {
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  font-family: "AmericanSans";
  color: #1B1F23;
  margin-bottom: 0;
}
p {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1B1F23;
}
adc-dialog.session-timeout-dialog::part(base) {
  z-index: 1000;
}
@media screen and (min-width: 800px) {
  adc-dialog::part(panel) {
    max-width: 540px;
    width: 540px;
    max-height: 260px;
  }
}
/*# sourceMappingURL=session-dialog.component-7EHTUH3U.css.map */
